<template>
  <div class="business-index">
    <ul class="business-index-tab-container" v-if="!showTab">
      <router-link class="business-index-tab-item" tag="li" :to="item.path" v-for="(item, i) in childMenu" :key="i">{{item.meta.title}}</router-link>
    </ul>
    <transition name="fade-transform" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'business-index',
    data() {
      return {
        showTab: false
      }
    },
    computed:{
      childMenu(){
        let allRoutes = this.$store.state.permission.addRoutes;
        let currentPrevParentRoute = this.$route.matched[1].path
        let currentParentRoute = this.$route.matched[2].path
        let childRouteList = []
        allRoutes.map( (item) => {
          if(item.name == 'layout'){
            item.children.map( (subItem) => {
              if(subItem.path == currentPrevParentRoute){
                subItem.children.map((lastLevel) => {
                  if(lastLevel.path == currentParentRoute){
                    childRouteList = lastLevel.children
                  }
                })

              }
            })
          }
        })
        console.log('childRouteList=',childRouteList)
       return childRouteList
      }
    },
    watch:{
      '$route' (to, from) {
        if(to.name == 'businessServiceRecord'){
          this.showTab = true
        }else {
          this.showTab = false
        }
      }
    },
    created(){
      let currentRoute = this.$route.name
      if(currentRoute == 'businessServiceRecord'){
        this.showTab = true
      }else {
        this.showTab = false
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">
.business-index{
  .business-index-tab-container{
    margin: 0;
    background-color: #fff;
    padding: 24px;
    display: flex;
    position: relative;
    .operate-record-btn{
      position: absolute;
      right: 20px;
      top: 50%;
      margin-top: -20px;
    }
    border-radius: $mainBorderRadius;
    .business-index-tab-item{
      margin-right: 40px;
      color: #333333;
      font-size: 12px;
      letter-spacing: 1.4px;
      cursor: pointer;
      padding-bottom: 7px;
      &.router-link-active{
        color: $mainColor;
        border-bottom:5px solid $mainColor;
      }
    }
  }
  .no-auth-view{
    text-align: center;
    line-height: 100px;
    font-size: 16px;
    color: #666;
  }
}
</style>
